import { render } from "./forgotpassword.vue?vue&type=template&id=9b3a2fac&scoped=true"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"

import "./forgotpassword.vue?vue&type=style&index=0&id=9b3a2fac&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3a2fac"]])

export default __exports__